// CJS like context-source-matrix.js: the plain-node unit suite requires it directly.
const SECONDS_PER_MINUTE = 60;
const MINUTES_PER_HOUR = 60;

// "30 min", "1 h", "1 h 30 min"; "" when either end is missing or the span is not
// positive, so a card never shows a made-up duration.
function formatEventDuration(startSeconds, endSeconds) {
  const start = Number(startSeconds);
  const end = Number(endSeconds);
  if (!start || !end || end <= start) {
    return "";
  }
  const totalMinutes = Math.round((end - start) / SECONDS_PER_MINUTE);
  const hours = Math.floor(totalMinutes / MINUTES_PER_HOUR);
  const minutes = totalMinutes % MINUTES_PER_HOUR;
  if (hours === 0) {
    return `${minutes} min`;
  }
  return minutes === 0 ? `${hours} h` : `${hours} h ${minutes} min`;
}

module.exports = { formatEventDuration };
module.exports.default = { formatEventDuration };
